import { configureStore } from "@reduxjs/toolkit";
import { mlbApi } from "./api/mlbApi";
import { nbaApi } from "./api/nbaApi";
import { nflApi } from "./api/nflApi";
import { queryBuilderApi } from "./api/queryBuilderApi";
import { communityApi } from "./api/communityApi";

export const store = configureStore({
  reducer: {
    [mlbApi.reducerPath]: mlbApi.reducer,
    [nbaApi.reducerPath]: nbaApi.reducer,
    [nflApi.reducerPath]: nflApi.reducer,
    [queryBuilderApi.reducerPath]: queryBuilderApi.reducer,
    [communityApi.reducerPath]: communityApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
        ignoredActionPaths: [
          "meta.arg",
          "payload.timestamp",
          "meta.baseQueryMeta.request",
          "meta.baseQueryMeta.response",
        ],
        ignoredPaths: ["mlbApi", "nbaApi", "nflApi", "queryBuilderApi", "communityApi"],
      },
      immutableCheck: {
        ignoredPaths: ["mlbApi", "nbaApi", "nflApi", "queryBuilderApi", "communityApi"],
      },
    }).concat(
      mlbApi.middleware,
      nbaApi.middleware,
      nflApi.middleware,
      queryBuilderApi.middleware,
      communityApi.middleware
    ),
});
